var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("g-breadcrumb", {
        attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
      }),
      _c("q-card-main", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-10 gvn-title-primary mrg-t-0" }, [
            _vm._v("\n        Identificação do Processo\n      ")
          ]),
          _c(
            "div",
            { staticClass: "col-sm-1 text-right" },
            [
              _vm.imprimir == true
                ? _c("q-tooltip", [_vm._v("Histórico de Movimentação")])
                : _vm._e(),
              _vm.imprimir == true
                ? _c(
                    "q-btn",
                    {
                      attrs: {
                        id: "visualizarHistorico",
                        name: "visualizarHistorico",
                        icon: "fas fa-history",
                        color: "primary",
                        flat: ""
                      },
                      on: { click: _vm.visualizarHistorico }
                    },
                    [_vm._v("  Histórico\n        ")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-sm-1 text-right" },
            [
              _vm.imprimir == true
                ? _c("q-tooltip", [_vm._v("Comprovante de encaminhamento")])
                : _vm._e(),
              _vm.imprimir == true
                ? _c(
                    "q-btn",
                    {
                      attrs: {
                        id: "imprimirComprovanteEncaminhamento",
                        name: "imprimirComprovanteEncaminhamento",
                        icon: "fa fa-print",
                        color: "primary",
                        flat: ""
                      },
                      on: { click: _vm.imprimirComprovanteEncaminhamento }
                    },
                    [_vm._v("  Imprimir\n        ")]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-sm-2 col-xs-4",
              staticStyle: { "padding-top": "9px" }
            },
            [
              _c("g-input", {
                ref: "refCodigo",
                attrs: {
                  id: "refCodigo",
                  name: "refCodigo",
                  tipo: "text",
                  etiqueta: "Código",
                  validacao: "numeric",
                  foco: false,
                  desabilitar: true
                },
                model: {
                  value: _vm.paginaStatus.aberturaProcesso.codProcesso,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.paginaStatus.aberturaProcesso,
                      "codProcesso",
                      $$v
                    )
                  },
                  expression: "paginaStatus.aberturaProcesso.codProcesso"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-sm-2 col-xs-4",
              staticStyle: { "padding-top": "9px" }
            },
            [
              _c("g-input", {
                ref: "refNumProcesso",
                attrs: {
                  id: "refNumProcesso",
                  name: "refNumProcesso",
                  mascara: "numero",
                  validacao: "Number",
                  tamanho: 10,
                  etiqueta: "Nº Processo",
                  foco: false,
                  desabilitar: _vm.paginaStatus.desabilitarEdicao
                },
                model: {
                  value: _vm.paginaStatus.aberturaProcesso.numProcesso,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.paginaStatus.aberturaProcesso,
                      "numProcesso",
                      $$v
                    )
                  },
                  expression: "paginaStatus.aberturaProcesso.numProcesso"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-sm-2 col-xs-4",
              staticStyle: { "padding-top": "9px" }
            },
            [
              _c("g-input", {
                ref: "refAnoProcesso",
                attrs: {
                  id: "refAnoProcesso",
                  name: "refAnoProcesso",
                  mascara: "numero",
                  validacao: "required | Number",
                  tamanho: 4,
                  etiqueta: "Ano Processo",
                  foco: false,
                  desabilitar: _vm.paginaStatus.desabilitarEdicao
                },
                model: {
                  value: _vm.paginaStatus.aberturaProcesso.anoProcesso,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.paginaStatus.aberturaProcesso,
                      "anoProcesso",
                      $$v
                    )
                  },
                  expression: "paginaStatus.aberturaProcesso.anoProcesso"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-sm-3 col-xs-6",
              staticStyle: { padding: "9px 30px 0 0" }
            },
            [
              _c("g-dateInput", {
                ref: "refDataHoraProcesso",
                attrs: {
                  id: "dataHoraProcesso",
                  name: "dataHoraProcesso",
                  etiqueta: "Data Abertura",
                  desabilitar: _vm.paginaStatus.desabilitarEdicao,
                  somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                  validacao: "required",
                  dataMax: new Date()
                },
                model: {
                  value: _vm.dataHoraProcesso,
                  callback: function($$v) {
                    _vm.dataHoraProcesso = $$v
                  },
                  expression: "dataHoraProcesso"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-sm-3 col-xs-6",
              staticStyle: { "padding-top": "9px" }
            },
            [
              _c("g-input", {
                ref: "refHorProcesso",
                attrs: {
                  mascara: "hora",
                  validacao: "hora",
                  tamanho: 5,
                  etiqueta: "Hora Processo",
                  foco: false,
                  desabilitar: _vm.paginaStatus.desabilitarEdicao
                },
                model: {
                  value: _vm.horaProcesso,
                  callback: function($$v) {
                    _vm.horaProcesso = $$v
                  },
                  expression: "horaProcesso"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-2 col-xs-4" },
            [
              _c("g-input", {
                ref: "refNumProtocolo",
                attrs: {
                  id: "refNumProtocolo",
                  name: "refNumProtocolo",
                  mascara: "numero",
                  etiqueta: "Nº Protocolo",
                  foco: false,
                  desabilitar: true
                },
                model: {
                  value: _vm.paginaStatus.aberturaProcesso.numProtocolo,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.paginaStatus.aberturaProcesso,
                      "numProtocolo",
                      $$v
                    )
                  },
                  expression: "paginaStatus.aberturaProcesso.numProtocolo"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-sm-2 col-xs-4" },
            [
              _c("g-input", {
                ref: "refNumProcessoExterno",
                attrs: {
                  id: "refNumProcessoExterno",
                  name: "refNumProcessoExterno",
                  mascara: "numero",
                  validacao: "Number",
                  tamanho: 10,
                  etiqueta: "Nº Processo Externo",
                  foco: false,
                  desabilitar: _vm.desabilitarNumProcessoExterno
                },
                model: {
                  value: _vm.paginaStatus.aberturaProcesso.numProcessoExterno,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.paginaStatus.aberturaProcesso,
                      "numProcessoExterno",
                      $$v
                    )
                  },
                  expression: "paginaStatus.aberturaProcesso.numProcessoExterno"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-sm-2 col-xs-4" },
            [
              _c("g-input", {
                ref: "refNumProcessoAnterior",
                attrs: {
                  id: "refNumProcessoAnterior",
                  name: "refNumProcessoAnterior",
                  mascara: "numero",
                  validacao: "Number",
                  tamanho: 10,
                  etiqueta: "Nº Processo Anterior",
                  foco: false,
                  desabilitar: _vm.desabilitarNumProcessoAnterior
                },
                model: {
                  value: _vm.paginaStatus.aberturaProcesso.numProcessoAnterior,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.paginaStatus.aberturaProcesso,
                      "numProcessoAnterior",
                      $$v
                    )
                  },
                  expression:
                    "paginaStatus.aberturaProcesso.numProcessoAnterior"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-sm-3 col-xs-6" },
            [
              _c("g-input", {
                ref: "refAnoProcessoAnterior",
                attrs: {
                  id: "refAnoProcessoAnterior",
                  name: "refAnoProcessoAnterior",
                  mascara: "numero",
                  validacao: "Number",
                  tamanho: 4,
                  etiqueta: "Ano Processo Anterior",
                  foco: false,
                  desabilitar: _vm.desabilitarAnoProcessoAnterior
                },
                model: {
                  value: _vm.paginaStatus.aberturaProcesso.anoProcessoAnterior,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.paginaStatus.aberturaProcesso,
                      "anoProcessoAnterior",
                      $$v
                    )
                  },
                  expression:
                    "paginaStatus.aberturaProcesso.anoProcessoAnterior"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-sm-3 col-xs-6" },
            [
              _c("g-input", {
                ref: "refCodigoBarra",
                attrs: {
                  id: "refCodigoBarra",
                  name: "refCodigoBarra",
                  tipo: "text",
                  etiqueta: "Código de Barras",
                  validacao: "maxlength(50)",
                  tamanho: 50,
                  foco: false,
                  desabilitar: true
                },
                model: {
                  value: _vm.codBarra,
                  callback: function($$v) {
                    _vm.codBarra = $$v
                  },
                  expression: "codBarra"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-2 col-sm-2 col-xs-4",
              staticStyle: { "padding-top": "10px" }
            },
            [
              _vm.exibirClone
                ? _c("q-toggle", {
                    attrs: {
                      id: "clonarProcesso",
                      name: "clonarProcesso",
                      label: "Clonar Processo",
                      color: "teal-8",
                      disable: _vm.paginaStatus.desabilitarEdicao,
                      "true-value": "S",
                      "false-value": "N",
                      "checked-icon": "check",
                      "unchecked-icon": "clear"
                    },
                    model: {
                      value: _vm.clonarProcesso,
                      callback: function($$v) {
                        _vm.clonarProcesso = $$v
                      },
                      expression: "clonarProcesso"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-2 col-sm-2 col-xs-4",
              staticStyle: { "margin-top": "-20px" }
            },
            [
              _vm.exibirClone
                ? _c("g-input", {
                    ref: "refQdeProcesso",
                    attrs: {
                      id: "refQdeProcesso",
                      name: "refQdeProcesso",
                      mascara: "numero",
                      validacao: "Number",
                      etiqueta: "Quantidade",
                      tamanho: 4,
                      foco: false,
                      desabilitar: _vm.clonarProcesso == "N"
                    },
                    model: {
                      value: _vm.qdeProcesso,
                      callback: function($$v) {
                        _vm.qdeProcesso = $$v
                      },
                      expression: "qdeProcesso"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _c(
        "q-card",
        [
          _c(
            "q-card-main",
            [
              _c(
                "q-tabs",
                {
                  attrs: { inverted: "" },
                  model: {
                    value: _vm.abaSelecionada,
                    callback: function($$v) {
                      _vm.abaSelecionada = $$v
                    },
                    expression: "abaSelecionada"
                  }
                },
                [
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      label: "Dados do processo",
                      name: "dadosProcesso"
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      label: "Dados do requerente",
                      name: "dadosRequerente"
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      label: "Dados complementares",
                      name: "dadosComplemetares"
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      label: "Documentos",
                      name: "documentos"
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      label: "Dados Impressão do Comprovante",
                      name: "comprovante"
                    },
                    slot: "title"
                  }),
                  _c("q-tab-pane", { attrs: { name: "dadosProcesso" } }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-xs-6" },
                        [
                          _c("g-autocomplete", {
                            ref: "refFormaSolicitacao",
                            attrs: {
                              id: "refFormaSolicitacao",
                              name: "refFormaSolicitacao",
                              etiqueta: "Forma de Solicitação",
                              valor: "codFormaSolicitacao",
                              validacao: "required | text",
                              foco: false,
                              descricaoPrimaria: "desFormaSolicitacao",
                              api: _vm.apiformaSolicitacao,
                              desabilitar: _vm.desabilitarFormaSolicitacao
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso
                                  .formaSolicitacao.codFormaSolicitacao,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso
                                    .formaSolicitacao,
                                  "codFormaSolicitacao",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.formaSolicitacao.codFormaSolicitacao"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-input", {
                            ref: "refVlrProcesso",
                            attrs: {
                              id: "refVlrProcesso",
                              name: "refVlrProcesso",
                              validacao: "Number",
                              mascara: "numeroDuasCasasDecimais",
                              tamanho: 14,
                              etiqueta: "Valor do Processo",
                              foco: false,
                              desabilitar: _vm.desabilitarVlrProcesso
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.vlrProcesso,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso,
                                  "vlrProcesso",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.vlrProcesso"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-input", {
                            ref: "refTxtProcesso",
                            attrs: {
                              id: "refTxtProcesso",
                              name: "refTxtProcesso",
                              validacao: "Number",
                              tamanho: 40,
                              etiqueta: "Nota Fiscal",
                              foco: false,
                              desabilitar: _vm.desabilitarNotaFiscal
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.txtNotaFiscal,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso,
                                  "txtNotaFiscal",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.txtNotaFiscal"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-3 col-xs-3" },
                        [
                          _c("g-input", {
                            ref: "refInscricaoImovel",
                            attrs: {
                              id: "refInscricaoImovel",
                              name: "refInscricaoImovel",
                              tamanho: 15,
                              etiqueta: "Inscrição Imóvel",
                              foco: false,
                              desabilitar: false
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.numInscricao,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso,
                                  "numInscricao",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.numInscricao"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.permissaoAcessoImovel
                        ? _c(
                            "div",
                            {
                              staticClass: "col-sm-1 col-xs-1",
                              staticStyle: { padding: "15px 30px 0 0" }
                            },
                            [
                              _c("q-btn", {
                                staticStyle: {
                                  background: "#550059 !important",
                                  color: "white"
                                },
                                attrs: { icon: "fa fa-search" },
                                on: { click: _vm.pesquisarImovel }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-xs-6" },
                        [
                          _c("g-input", {
                            ref: "refEnderecoImovel",
                            attrs: {
                              id: "refEnderecoImovel",
                              name: "refEnderecoImovel",
                              tamanho: 150,
                              etiqueta: "Endereço Imóvel",
                              foco: false,
                              desabilitar: false
                            },
                            model: {
                              value: _vm.desEndereco,
                              callback: function($$v) {
                                _vm.desEndereco = $$v
                              },
                              expression: "desEndereco"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-3 col-xs-3" },
                        [
                          _c("g-input", {
                            ref: "refTipoImovel",
                            attrs: {
                              id: "refTipoImovel",
                              name: "refTipoImovel",
                              tamanho: 50,
                              etiqueta: "Tipo de Imposto",
                              foco: false,
                              desabilitar: false
                            },
                            model: {
                              value: _vm.tipoImovel,
                              callback: function($$v) {
                                _vm.tipoImovel = $$v
                              },
                              expression: "tipoImovel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-3 col-xs-3" },
                        [
                          _c("g-input", {
                            ref: "refAreaLote",
                            attrs: {
                              id: "refAreaLote",
                              name: "refAreaLote",
                              tamanho: 22,
                              etiqueta: "Área do Lote",
                              validacao: "Number",
                              mascara: "numeroDuasCasasDecimais",
                              foco: false,
                              desabilitar: false
                            },
                            model: {
                              value: _vm.areaLote,
                              callback: function($$v) {
                                _vm.areaLote = $$v
                              },
                              expression: "areaLote"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-xs-6" },
                        [
                          _c("g-autocomplete", {
                            ref: "refTipoProcesso",
                            attrs: {
                              id: "refTipoProcesso",
                              name: "refTipoProcesso",
                              etiqueta: "Tipo de Processo",
                              valor: "codTipoProcesso",
                              validacao: "required | text",
                              foco: false,
                              descricaoPrimaria: "desTipoProcesso",
                              api: _vm.apitipoProcesso,
                              desabilitar: _vm.desabilitarTipoProcesso,
                              acaoPosSelecao: _vm.buscarDadosTipoProcesso,
                              onchange: _vm.mudanca()
                            },
                            model: {
                              value: _vm.codTipoProcesso,
                              callback: function($$v) {
                                _vm.codTipoProcesso = $$v
                              },
                              expression: "codTipoProcesso"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-xs-6" },
                        [
                          _c("g-autocomplete", {
                            ref: "refAssunto",
                            attrs: {
                              id: "refAssunto",
                              name: "refAssunto",
                              etiqueta: "Assunto",
                              valor: "codAssunto",
                              foco: false,
                              validacao: "required",
                              descricaoPrimaria: "desAssunto",
                              api: _vm.apiAssunto,
                              filtroAdicional: _vm.getFiltroAssunto,
                              onchange: _vm.mudanca(),
                              desabilitar: _vm.desabilitarAssunto
                            },
                            model: {
                              value: _vm.codAssunto,
                              callback: function($$v) {
                                _vm.codAssunto = $$v
                              },
                              expression: "codAssunto"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-xs-6" },
                        [
                          _c("g-autocomplete", {
                            ref: "refSubAssunto",
                            attrs: {
                              id: "refSubAssunto",
                              name: "refSubAssunto",
                              etiqueta: "Subassunto",
                              foco: false,
                              valor: "codSubassunto",
                              validacao: "required",
                              descricaoPrimaria: "desSubassunto",
                              desabilitar: _vm.desabilitarSubAssunto,
                              api: _vm.apiSubAssunto,
                              filtroAdicional: _vm.getFiltroSubAssunto,
                              acaoPosSelecao: _vm.buscarDocumentoNecessario,
                              onchange: _vm.mudanca()
                            },
                            model: {
                              value: _vm.codSubassunto,
                              callback: function($$v) {
                                _vm.codSubassunto = $$v
                              },
                              expression: "codSubassunto"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-xs-6" },
                        [
                          _c("g-select", {
                            ref: "refNumRota",
                            attrs: {
                              id: "refNumRota",
                              name: "refNumRota",
                              etiqueta: "Nº da Rota",
                              foco: false,
                              itens: _vm.rotaArray,
                              "item-valor": "numRota",
                              "item-etiqueta": "numRota",
                              desabilitar: _vm.desabilitarRota,
                              adicionarLinhaEmBranco: false,
                              change: _vm.buscarDadosRoteiro
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.roteiro
                                  .numRota,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso.roteiro,
                                  "numRota",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.roteiro.numRota"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 col-xs-12" },
                        [
                          _c("g-autocomplete", {
                            ref: "refJustificativa",
                            attrs: {
                              id: "refJustificativa",
                              name: "refJustificativa",
                              etiqueta: "Justificativa",
                              valor: "codJustificativa",
                              foco: false,
                              validacao: "required",
                              descricaoPrimaria: "desJustificativa",
                              desabilitar: _vm.desabilitarJustificativa,
                              api: _vm.apiJustificativa,
                              filtroAdicional: _vm.getFiltroJustificativa
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.justificativa
                                  .codJustificativa,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso
                                    .justificativa,
                                  "codJustificativa",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.justificativa.codJustificativa"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 col-xs-12" },
                        [
                          _c("g-timeLine", {
                            ref: "refTimeLine",
                            attrs: {
                              id: "refTimeLine",
                              name: "refTimeLine",
                              itens: _vm.dadosRoteiroArray,
                              titulo: "Etapas da sequência",
                              conteudo:
                                "{n}{d}Previsão de dias:{/d} {p}numPrevisaoDias{/p} | {p}setor.unidade.orgao.desOrgao{/p} | {p}setor.unidade.desUnidade{/p} | {n}{p}setor.desSetor{/p}"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _c("q-tab-pane", { attrs: { name: "dadosRequerente" } }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 col-xs-12" },
                        [
                          _c("g-autocomplete", {
                            ref: "refRequerente",
                            attrs: {
                              id: "refRequerente",
                              name: "refRequerente",
                              etiqueta: "Requerente",
                              valor: "codRequerente",
                              foco: false,
                              validacao: "required",
                              descricaoPrimaria: "nomeDataNascimentoDocumento",
                              acaoPosSelecao: _vm.buscarDadosRequerente,
                              desabilitar: _vm.paginaStatus.desabilitarEdicao,
                              api: _vm.apiRequerente,
                              limparAdicional: _vm.limparDadosRequerente
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.requerente
                                  .codRequerente,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso.requerente,
                                  "codRequerente",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.requerente.codRequerente"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.operacao === "Novo"
                        ? _c("div", { staticClass: "col-sm-1 col-xs-1" })
                        : _vm._e()
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-input", {
                            ref: "refTelefoneMovel",
                            attrs: {
                              id: "refTelefoneMovel",
                              name: "refTelefoneMovel",
                              mascara: "telefone",
                              validacao: "Text",
                              etiqueta: "Telefone Celular",
                              foco: false,
                              desabilitar: _vm.desabilitarTelefoneRequerente
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.requerente
                                  .numTelefoneMovel,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso.requerente,
                                  "numTelefoneMovel",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.requerente.numTelefoneMovel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-input", {
                            ref: "refTelefoneResidencial",
                            attrs: {
                              id: "refTelefoneResidencial",
                              name: "refTelefoneResidencial",
                              mascara: "telefone",
                              validacao: "Text",
                              etiqueta: "Telefone Residencial",
                              foco: false,
                              desabilitar: _vm.desabilitarTelefoneRequerente
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.requerente
                                  .numTelefoneResidencial,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso.requerente,
                                  "numTelefoneResidencial",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.requerente.numTelefoneResidencial"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-input", {
                            ref: "refTelefoneComercial",
                            attrs: {
                              id: "refTelefoneComercial",
                              name: "refTelefoneComercial",
                              mascara: "telefone",
                              validacao: "Text",
                              etiqueta: "Telefone Comercial",
                              foco: false,
                              desabilitar: _vm.desabilitarTelefoneRequerente
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.requerente
                                  .numTelefoneComercial,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso.requerente,
                                  "numTelefoneComercial",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.requerente.numTelefoneComercial"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 col-xs-12" },
                        [
                          _c("g-autocomplete", {
                            ref: "refRepresentante",
                            attrs: {
                              id: "refRepresentante",
                              name: "refRepresentante",
                              etiqueta: "Representante",
                              valor: "codRepresentante",
                              foco: false,
                              validacao: "text",
                              descricaoPrimaria: "nomeDataNascimentoDocumento",
                              acaoPosSelecao: _vm.buscarDadosRepresentante,
                              desabilitar: _vm.paginaStatus.desabilitarEdicao,
                              api: _vm.apiRequerente,
                              limparAdicional: _vm.limparDadosRepresentante
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.representante
                                  .codRepresentante,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso
                                    .representante,
                                  "codRepresentante",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.representante.codRepresentante"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-input", {
                            ref: "refTelefoneMovelRepresentante",
                            attrs: {
                              id: "refTelefoneMovelRepresentante",
                              name: "refTelefoneMovelRepresentante",
                              mascara: "telefone",
                              validacao: "Text",
                              etiqueta: "Telefone Celular",
                              foco: false,
                              desabilitar: _vm.desabilitarTelefoneRepresentante
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.representante
                                  .numTelefoneMovel,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso
                                    .representante,
                                  "numTelefoneMovel",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.representante.numTelefoneMovel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-input", {
                            ref: "refTelefoneResidencialRepresentante",
                            attrs: {
                              id: "refTelefoneResidencialRepresentante",
                              name: "refTelefoneResidencialRepresentante",
                              mascara: "telefone",
                              validacao: "Text",
                              etiqueta: "Telefone Residencial",
                              foco: false,
                              desabilitar: _vm.desabilitarTelefoneRepresentante
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.representante
                                  .numTelefoneResidencial,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso
                                    .representante,
                                  "numTelefoneResidencial",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.representante.numTelefoneResidencial"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-input", {
                            ref: "refTelefoneComercialRepresentante",
                            attrs: {
                              id: "refTelefoneComercialRepresentante",
                              name: "refTelefoneComercialRepresentante",
                              mascara: "telefone",
                              validacao: "Text",
                              etiqueta: "Telefone Comercial",
                              foco: false,
                              desabilitar: _vm.desabilitarTelefoneRepresentante
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.representante
                                  .numTelefoneComercial,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso
                                    .representante,
                                  "numTelefoneComercial",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.representante.numTelefoneComercial"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 col-xs-12" },
                        [
                          _c("g-input", {
                            ref: "refEmail",
                            attrs: {
                              id: "refEmail",
                              name: "refEmail",
                              validacao: "email | maxlength(100)",
                              tamanho: 100,
                              etiqueta: "E-mail",
                              foco: false,
                              desabilitar: _vm.paginaStatus.desabilitarEdicao
                            },
                            model: {
                              value: _vm.paginaStatus.aberturaProcesso.txtEmail,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso,
                                  "txtEmail",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.txtEmail"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _c("q-tab-pane", { attrs: { name: "dadosComplemetares" } }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-sm-6 col-xs-6",
                          staticStyle: { "padding-top": "9px" }
                        },
                        [
                          _c("g-input", {
                            ref: "refCapa",
                            attrs: {
                              id: "refCapa",
                              name: "refCapa",
                              validacao: "required | Text",
                              etiqueta: "Capa Processo (Cor)",
                              foco: false,
                              desabilitar: true
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.tipoProcesso
                                  .txtCapaCor,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso
                                    .tipoProcesso,
                                  "txtCapaCor",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.tipoProcesso.txtCapaCor"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "col-sm-3 col-xs-3",
                          staticStyle: { "padding-top": "9px" }
                        },
                        [
                          _c("g-input", {
                            ref: "refTramitacao",
                            attrs: {
                              id: "refTramitacao",
                              name: "refTramitacao",
                              validacao: "required | Text",
                              etiqueta: "Tempo Tramitação (Dias úteis)",
                              foco: false,
                              desabilitar: true
                            },
                            model: {
                              value: _vm.numPrevisao,
                              callback: function($$v) {
                                _vm.numPrevisao = $$v
                              },
                              expression: "numPrevisao"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "col-sm-3 col-xs-3",
                          staticStyle: { padding: "9px 30px 0 0" }
                        },
                        [
                          _c("g-input", {
                            ref: "refDataEstimativaConclusao",
                            attrs: {
                              id: "refDataEstimativaConclusao",
                              name: "refDataEstimativaConclusao",
                              etiqueta: "Data Estimativa Conclusão",
                              foco: false,
                              desabilitar: true
                            },
                            model: {
                              value: _vm.dataEstimativaConclusao,
                              callback: function($$v) {
                                _vm.dataEstimativaConclusao = $$v
                              },
                              expression: "dataEstimativaConclusao"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 col-xs-12" },
                        [
                          _c("g-input", {
                            ref: "refObservacao",
                            attrs: {
                              id: "refObservacao",
                              name: "refObservacao",
                              etiqueta: "Observação",
                              validacao: "Text | maxlength(5000)",
                              tipo: "textarea",
                              tamanho: 5000,
                              foco: false,
                              desabilitar: _vm.desabilitarObs
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.txtObservacao,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso,
                                  "txtObservacao",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.txtObservacao"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-xs-6" },
                        [
                          _c("g-input", {
                            ref: "reforgaoOrigem",
                            attrs: {
                              id: "reforgaoOrigem",
                              name: "reforgaoOrigem",
                              tipo: "text",
                              etiqueta: "Órgão Origem",
                              validacao: "required",
                              foco: false,
                              desabilitar: true
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.roteiro.setor
                                  .unidade.orgao.desOrgao,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso.roteiro
                                    .setor.unidade.orgao,
                                  "desOrgao",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.roteiro.setor.unidade.orgao.desOrgao"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-xs-6" },
                        [
                          _c("g-input", {
                            ref: "refunidadeOrigem",
                            attrs: {
                              id: "refunidadeOrigem",
                              name: "refunidadeOrigem",
                              tipo: "text",
                              etiqueta: "Unidade Origem",
                              validacao: "required",
                              foco: false,
                              desabilitar: true
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.roteiro.setor
                                  .unidade.desUnidade,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso.roteiro
                                    .setor.unidade,
                                  "desUnidade",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.roteiro.setor.unidade.desUnidade"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-xs-6" },
                        [
                          _c("g-input", {
                            ref: "refSetorOrigem",
                            attrs: {
                              id: "refSetorOrigem",
                              name: "refSetorOrigem",
                              tipo: "text",
                              etiqueta: "Setor Origem",
                              validacao: "required",
                              foco: false,
                              desabilitar: true
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.roteiro.setor
                                  .desSetor,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso.roteiro
                                    .setor,
                                  "desSetor",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.roteiro.setor.desSetor"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-xs-6" },
                        [
                          _c("g-autocomplete", {
                            ref: "refResponsavel",
                            attrs: {
                              id: "refResponsavel",
                              name: "refResponsavel",
                              etiqueta: "Responsável",
                              valor: "codResponsavel",
                              foco: false,
                              validacao: "required",
                              descricaoPrimaria: "usuario.nomUsuario",
                              desabilitar: true,
                              api: _vm.apiResponsavelSetor,
                              filtroAdicional: _vm.getFiltroResponsavel
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.responsavel
                                  .codResponsavel,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso.responsavel,
                                  "codResponsavel",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.responsavel.codResponsavel"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "documentos" } },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.dadosDocumentoNecessarioArray.length > 0,
                              expression:
                                "dadosDocumentoNecessarioArray.length > 0"
                            }
                          ],
                          staticClass: "row mrg-b-20"
                        },
                        [
                          _c(
                            "table",
                            {
                              staticClass: "col-md-12",
                              attrs: { cellspacing: "0", cellpadding: "0" }
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticClass: "text-left",
                                      attrs: { width: "50%" }
                                    },
                                    [_vm._v("Documentação Necessária Entregue")]
                                  )
                                ])
                              ]),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.dadosDocumentoNecessarioArray,
                                  function(doc) {
                                    return _c("tr", { key: doc.a }, [
                                      _c(
                                        "td",
                                        { staticClass: "text-left" },
                                        [
                                          _c("q-toggle", {
                                            attrs: {
                                              id: "desabilitarDocumentos",
                                              name: "desabilitarDocumentos",
                                              disable:
                                                _vm.desabilitarDocumentos,
                                              color: "teal-8",
                                              val: doc,
                                              "true-value": "S",
                                              "false-value": "N",
                                              "checked-icon": "check",
                                              "unchecked-icon": "clear"
                                            },
                                            model: {
                                              value: _vm.documentoToggle,
                                              callback: function($$v) {
                                                _vm.documentoToggle = $$v
                                              },
                                              expression: "documentoToggle"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                      \n                    " +
                                              _vm._s(
                                                doc.documento.nomDocumento
                                              ) +
                                              "\n                  "
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  }
                                )
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "g-gridview",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: this.clonarProcesso === "N",
                              expression: "this.clonarProcesso === 'N'"
                            }
                          ],
                          ref: "refGridDocumentos",
                          attrs: {
                            id: "refGridDocumentos",
                            name: "refGridDocumentos",
                            exibirEtiqueta: false,
                            colunas: _vm.colunasGrid,
                            inserirElemento: _vm.setElemento,
                            getElemento: _vm.getElemento,
                            editarElemento: _vm.editarElemento,
                            executarValidacao: _vm.validarDocumento,
                            limparCampos: _vm.limparDocumento,
                            exibirBotaoExclusaoFuncao: _vm.exibirBotaoExclusao,
                            confExcluir: _vm.confExcluirDocumento,
                            inicializarVazio: true,
                            exibirBotaoVisualizacao: false,
                            exibirBotaoEdicao: false,
                            operacoes: _vm.operacoes
                          }
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "titulo-modal-processo col-lg-12 col-md-12 col-sm-12 col-xs-12"
                              },
                              [
                                _c("i", {
                                  staticClass: "titulo-icone fas fa-file"
                                }),
                                _vm._v(
                                  " Arquivos anexados na solicitação\n              "
                                )
                              ]
                            )
                          ]),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "col-sm-6 col-xs-6",
                                staticStyle: { "padding-top": "9px" }
                              },
                              [
                                _c("q-uploader", {
                                  ref: "refUploader",
                                  attrs: {
                                    color: "secondary",
                                    name: "arquivo",
                                    type: "file",
                                    "auto-expand": "",
                                    "hide-upload-button": "",
                                    "hide-upload-progress": "",
                                    validacao: "required",
                                    "stack-label":
                                      "Selecionar arquivo (Tamanho máximo: 200Mb)",
                                    url: _vm.urlArquivo,
                                    filter: _vm.filtroDeArquivos
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "col-sm-6 col-xs-6",
                                staticStyle: { "padding-top": "9px" }
                              },
                              [
                                _c("g-input", {
                                  ref: "refDocumento",
                                  attrs: {
                                    id: "refDocumento",
                                    name: "refDocumento",
                                    tipo: "text",
                                    etiqueta: "Documento",
                                    tamanho: 100,
                                    foco: false
                                  },
                                  model: {
                                    value: _vm.nomDocumento,
                                    callback: function($$v) {
                                      _vm.nomDocumento = $$v
                                    },
                                    expression: "nomDocumento"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "col-sm-12 col-xs-12",
                                staticStyle: { "padding-top": "9px" }
                              },
                              [
                                _c("g-input", {
                                  ref: "refObservacao",
                                  attrs: {
                                    id: "refObservacao",
                                    name: "refObservacao",
                                    tipo: "textarea",
                                    etiqueta: "Observação",
                                    tamanho: 1000,
                                    foco: false
                                  },
                                  model: {
                                    value: _vm.txtObservacao,
                                    callback: function($$v) {
                                      _vm.txtObservacao = $$v
                                    },
                                    expression: "txtObservacao"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c("q-tab-pane", { attrs: { name: "comprovante" } }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-sm-3 col-xs-3",
                          staticStyle: { "padding-top": "30px" }
                        },
                        [
                          _c("q-toggle", {
                            attrs: {
                              id: "indLiberadoProtocolo",
                              name: "indLiberadoProtocolo",
                              label: "Liberado pelo Protocolo",
                              color: "teal-8",
                              disable: _vm.desabilitarComprovante,
                              "true-value": "S",
                              "false-value": "N",
                              "checked-icon": "check",
                              "unchecked-icon": "clear"
                            },
                            model: {
                              value: _vm.indLiberadoProtocolo,
                              callback: function($$v) {
                                _vm.indLiberadoProtocolo = $$v
                              },
                              expression: "indLiberadoProtocolo"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-xs-6" },
                        [
                          _c("g-input", {
                            ref: "refContato",
                            attrs: {
                              id: "refContato",
                              name: "refContato",
                              validacao: "Text | maxlength(100)",
                              tamanho: 100,
                              tipo: "text",
                              etiqueta: "Contato",
                              foco: false,
                              desabilitar: _vm.desabilitarComprovante
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso.txtContato,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso,
                                  "txtContato",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.txtContato"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-xs-6" },
                        [
                          _c("g-input", {
                            ref: "refIdentificacao",
                            attrs: {
                              id: "refIdentificacao",
                              name: "refIdentificacao",
                              validacao: "Text | maxlength(100)",
                              tamanho: 100,
                              tipo: "text",
                              etiqueta: "Identificação",
                              foco: false,
                              desabilitar: _vm.desabilitarComprovante
                            },
                            model: {
                              value:
                                _vm.paginaStatus.aberturaProcesso
                                  .txtIdentificacao,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paginaStatus.aberturaProcesso,
                                  "txtIdentificacao",
                                  $$v
                                )
                              },
                              expression:
                                "paginaStatus.aberturaProcesso.txtIdentificacao"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("br"),
                    _c("br"),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
                        },
                        [
                          _vm._v(
                            "\n              Endereço:  Requerente/Contribuinte \n              "
                          ),
                          _c("q-toggle", {
                            attrs: {
                              id: "indTipoEndereco",
                              name: "indTipoEndereco",
                              label: "Imóvel do Contribuinte",
                              color: "teal-8",
                              disable: _vm.desabilitarComprovante,
                              "true-value": "I",
                              "false-value": "R",
                              "checked-icon": "check",
                              "unchecked-icon": "clear"
                            },
                            model: {
                              value: _vm.indTipoEndereco,
                              callback: function($$v) {
                                _vm.indTipoEndereco = $$v
                              },
                              expression: "indTipoEndereco"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 text-right pad-20t-h10-80b" },
        [
          _c(
            "q-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visualizarSalvar,
                  expression: "visualizarSalvar"
                }
              ],
              staticClass: "fixed",
              staticStyle: { right: "18px", bottom: "18px" },
              attrs: {
                round: "",
                id: "salvar",
                name: "salvar",
                color: "positive",
                icon: "check",
                size: "lg"
              },
              on: { click: _vm.salvar }
            },
            [_c("q-tooltip", [_vm._v("Salvar")])],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }